export default {"src":"/_next/static/media/traded2.6d71e6e4.svg","height":48,"width":49};